import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IvrSpecies from "../IvrSpecies";
import { toast } from "react-toastify";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

export default function SpeciesCatch({
  catchList,
  type,
  addCatch,
  isVisible = false,
  setIsVisible,
  currentItem,
  currentlyEditing,
  setCurrentlyEditing,
  stopEditing,
  onDelete,
}) {
  const [open, setOpen] = useState(isVisible);
  const [speciescd, setSpecies] = useState({});
  const [kept, setKept] = useState(0);
  const [discarded, setDiscarded] = useState(0);
  const [itemIdx, setItemIdx] = useState(0);
  const [errors, setErrors] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const checkCatchExists = (newCatch) => {
    return catchList.some((obj) => obj.id === `${newCatch.id}`);
  };

  const formIsValid = () => {
    const errors = {};
    if (Object.keys(speciescd).length === 0)
      errors.speciescd = "The Species is required.";
    if (kept < 0 || !kept) errors.kept = "LB Kept is required.";
    if (type === "efp" && (discarded < 0 || !discarded))
      errors.discarded = "LB Discarded is required.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = () => {
    const newCatch = { ...speciescd, kept, discarded };
    let newCatchList = [...catchList];

    if (!formIsValid()) {
      return;
    }

    if (checkCatchExists(newCatch) && !currentlyEditing) {
      toast.error("You may have add an existing catch.", { autoClose: false });
      return;
    }
    if (currentlyEditing) {
      console.log("Current Catch List", catchList[itemIdx].id);

      if (
        catchList[itemIdx].id !== speciescd.id &&
        checkCatchExists(newCatch)
      ) {
        toast.error("You may have add an existing catch.", {
          autoClose: false,
        });
        return;
      }
      newCatchList[itemIdx] = {
        ...speciescd,
        kept,
        discarded,
      };
      addCatch([...newCatchList]);
    } else {
      addCatch([...catchList, newCatch]);
    }
    console.log("Final Catch List", catchList);
    setOpen(false);
    setIsVisible(false);
    stopEditing();
    setCurrentlyEditing(false);
  };

  const handleClose = () => {
    setCurrentlyEditing(false);
    setOpen(false);
    setIsVisible(false);
  };

  const handleDelete = () => {
    console.log("Deleting item", itemIdx);
    stopEditing();
    setCurrentlyEditing(false);
    setOpen(false);
    setIsVisible(false);
    onDelete(itemIdx);
  };

  const handleChange = (event, reason) => {
    const { name, value } = event.target;

    if (name === "kept") setKept(value);
    else if (name === "discarded") setDiscarded(value);
    else if (reason) {
      if (reason.hasOwnProperty("id") && reason.hasOwnProperty("label")) {
        setSpecies({ id: reason.id, name: reason.label });
      }
    } else {
      setSpecies({});
    }
  };

  useEffect(() => {
    if (Object.keys(currentItem).length > 0) {
      setSpecies({ id: currentItem.id, name: currentItem.name });
      setKept(currentItem.kept);
      setDiscarded(currentItem.discarded);
      setItemIdx(currentItem.idx);
    }
  }, [currentItem]);

  console.log("Initial Catch List", catchList, currentlyEditing, currentItem);
  return (
    <>
      <Box p={1}>
        <Button
          color="primary"
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleClickOpen}
        >
          Add Catch
        </Button>
      </Box>

      <Box display="flex" justifyContent="center">
        <Dialog
          open={open || isVisible}
          onClose={handleClose}
          aria-labelledby="species-catch-form"
          maxWidth="xs"
          TransitionProps={{
            onExit: () => {
              setKept();
              setSpecies({});
              setDiscarded();
              setErrors([]);
              setOpen(false);
              setIsVisible(false);
              stopEditing();
            },
          }}
        >
          <DialogTitle id="species-catch-form">
            <Typography align="center">Catch Information</Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add a catch select the Species and introduce the amount of LB
              Kept.
            </DialogContentText>
            <IvrSpecies
              id="speciescd"
              name="speciescd"
              value={speciescd}
              onChange={handleChange}
            />
            {errors.speciescd && (
              <Alert severity="error">{errors.speciescd}</Alert>
            )}

            <Box mt={1}>
              <TextField
                name="kept"
                label="LB Kept"
                className="number-of-input"
                variant="standard"
                type="number"
                placeholder="LB Kept"
                typeof="numeric"
                value={kept || ""}
                inputProps={{ min: 0, style: { textAlign: "center" } }}
                onChange={handleChange}
              />
              {errors.kept && <Alert severity="error">{errors.kept}</Alert>}
            </Box>

            {type === "efp" && (
              <Box mt={1}>
                <TextField
                  name="discarded"
                  label="LB Discarded"
                  className="number-of-input"
                  variant="standard"
                  type="number"
                  placeholder="LB Discarded"
                  typeof="numeric"
                  value={discarded || ""}
                  inputProps={{ min: 0, style: { textAlign: "center" } }}
                  onChange={handleChange}
                />
                {errors.discarded && (
                  <Alert severity="error">{errors.discarded}</Alert>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs="auto">
                <Button
                  variant="contained"
                  className="warningBtn"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs="auto">
                <Button
                  variant="contained"
                  className="successBtn"
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Grid>
              {currentlyEditing && (
                <Grid item xs="auto">
                  <Button
                    variant="contained"
                    className="dangerBtn"
                    onClick={handleDelete}
                  >
                    Delete
                  </Button>
                </Grid>
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
